/** Ensure FK id fields are strings for select inputs after API merge. */
export function normalizeCustomerEditForm<T extends Record<string, unknown>>(payload: Partial<T>): Partial<T> {
  const next = { ...payload } as Record<string, unknown>
  for (const key of ["area_id", "isp_id", "sub_zone_id", "technician_id", "router_id", "dish_id"]) {
    if (next[key] != null && next[key] !== "") {
      next[key] = String(next[key])
    }
  }
  return next as Partial<T>
}

/** Inactive FK option for selects when list dropdown omits the current value. */
export function inactiveSelectOption(
  id: string | undefined | null,
  options: { id: string }[],
  label: string | undefined | null,
  fallback = "Current selection (inactive)",
) {
  if (!id || options.some((row) => row.id === id)) {
    return null
  }
  return { value: id, label: label?.trim() || fallback }
}
